import { MinigameRegistry } from '@core/registry/MinigameRegistry';
import { rhythmMinigame } from '@modules/rhythm';
import { adventureMinigame } from '@modules/adventure';
import { dressUpMinigame } from '@modules/dressup';
import { triviaMinigame } from '@modules/trivia';
import { memoryMinigame } from '@modules/memory';

/**
 * Punto unico donde se dan de alta todos los minijuegos. Para agregar uno nuevo:
 * 1. Crear su carpeta en src/modules/<nombre> con su escena y su definicion.
 * 2. Importar su definicion aca y sumarla al arreglo.
 * El hub y la config de Phaser se actualizan solos a partir del registry.
 */
export function registerMinigames(): void {
  MinigameRegistry.registerMany([
    rhythmMinigame,
    adventureMinigame,
    dressUpMinigame,
    triviaMinigame,
    memoryMinigame,
  ]);
}
